<template>
    <label
        :for="labelFor"
        class="af-label afu-text-black afu-block afu-mb-2 af-text--7xl afu-font-semibold"
    >
        <slot />
    </label>
</template>

<script>
    export default {
        name: 'C1Label',

        props: {
            labelFor: {
                type: String,
                default: undefined,
            },
        },
    };
</script>
